export default __webpack_public_path__ + "static/home-compute1-image-4bc20253e81ee9d4b2882969b7041cfd.png";